import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoadSecondary } from '../../../store/state/monitoring/transport/models';
import { DateType, DeviationType, LoadStatus } from '../../../store';
import { IconNames } from '../../../common/constants/icon-names';
import { IntrackFeatureModule } from '../../../intrack-feature.module';
import { StatusCodeComponent } from '../../status-code/status-code.component';
import { TransportModeComponent } from '../../transport-mode/transport-mode.component';
import { DatesComponent } from '../../monitoring/dates/dates.component';
import { DeviationTypeComponent } from '../../deviation-type';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';

@Component({
  selector: 'ui-load-info-bar-header-dates',
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    IntrackFeatureModule,
    StatusCodeComponent,
    TransportModeComponent,
    DatesComponent,
    DeviationTypeComponent,
    SvgIconComponent,
  ],
  templateUrl: './load-info-bar-header-dates.component.html',
  styleUrls: ['./load-info-bar-header-dates.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadInfoBarHeaderDatesComponent {
  @Input() load: LoadSecondary;
  @Input() loadStatus: LoadStatus;
  @Input() hasLabel: boolean;
  @Input() hasSpeedUpInfo: boolean;

  deviationType = DeviationType;
  dateType = DateType;
  iconNameList = IconNames;
}
